import { useCallback } from "react";
import * as overviewService from "../service/overview";
import useOverviewStore from "../store/overview";

export const useServiceEndpoints = () => {
  const { endpointsByService, endpointLoadingFor, setServiceEndpoints, setEndpointLoadingFor } =
    useOverviewStore();

  const getEndpoints = useCallback(
    async (serviceName) => {
      if (endpointsByService[serviceName]) return endpointsByService[serviceName];
      setEndpointLoadingFor(serviceName);
      try {
        const data = await overviewService.getServiceEndpoints(serviceName);
        setServiceEndpoints(serviceName, data);
        return data;
      } catch (error) {
        console.error("Failed to fetch service endpoints:", error);
        return null;
      } finally {
        setEndpointLoadingFor(null);
      }
    },
    [endpointsByService, setServiceEndpoints, setEndpointLoadingFor]
  );

  return { endpointsByService, endpointLoadingFor, getEndpoints };
};
